import i18next from 'i18next';
import React, { Fragment } from 'react';
import { isMobileDevice } from './deviceUtils';

export const renderTextWithLineBreaks = text => text && text.split('\n').map((line, index) => (
  <Fragment key={index}>
    {line}
    <br />
  </Fragment>
));

export const renderTextWithLineBreaksAndSymbolColor = text => text && text.split('\n').map((line, index) => (
  <Fragment key={index}>
    {line.split(/(♦︎|♥)/).map((part, i) => (part === '♦︎' || part === '♥' ? (
      <span key={i} style={{ color: 'red' }}>
        {part}
      </span>
    ) : (
      part
    )))}
    <br />
  </Fragment>
));

export const isFourDigitString = (str) => {
  const pattern = /^\d{4}$/;
  return pattern.test(str);
};

export const trimString = (str, allowedLength) => {
  if (str.length > allowedLength) {
    return `${str.substring(0, allowedLength)}...`;
  }
  return str;
};

export const capitalizeFirstLetter = str => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

// export const breakLongWord = ( inputString, breakLength ) => {
//     const chunks = inputString.split(/(\s+)/); // Split by spaces while preserving spaces as chunks
//     const wrappedChunks = chunks.map((chunk, index) => {
//         if (chunk.trim() !== '' && chunk.length > breakLength) {
//             return (
//             <span key={index} style={{ wordBreak: 'break-all' }}>
//                 {chunk}
//             </span>
//             );
//         }
//         return chunk;
//     });

//     return <div style={{ wordBreak: 'break-word' }}>{wrappedChunks}</div>;
// };

export const breakLongWord = (inputString, breakLength, linkStyle) => {
  if (!linkStyle) {
    linkStyle = {};
  }
  // Split by spaces while preserving spaces as chunks
  const chunks = inputString.split(/(\s+)/);

  // Regular expression to match links
  // const linkRegex = /(?:https?|ftp):\/\/[\n\S]+/g;
  const linkRegex = /(https?:\/\/[^\s]+|www\.[^\s]+|\b[^\s]+\.(?:lv|com)\/?)/gi;

  // Iterate over chunks and identify links
  const wrappedChunks = chunks.map((chunk, index) => {
    // Check if the chunk is a link
    if (chunk.match(linkRegex)) {
      // If it's a link, return it as a separate chunk
      const href = chunk.includes('@') ? (
        `mailto:${chunk}`
      ) : (chunk.startsWith("http://") || chunk.startsWith("https://")
        ? chunk
        : `https://${chunk}`
      )
      
      return (
        <a key={index} href={href} style={linkStyle} target="_blank" rel="noopener noreferrer">
          {chunk}
        </a>
      );
    } if (chunk.trim() !== '' && chunk.length > breakLength) {
      // If it's not a link but longer than breakLength, wrap it with span
      return (
        <span key={index} style={{ wordBreak: 'break-all' }}>
          {chunk}
        </span>
      );
    }
    // Otherwise, return the chunk as is
    return chunk;
  });

  return <div style={{ wordBreak: 'break-word' }}>{wrappedChunks}</div>;
};

export const renderFileName = (fileName, maxLength) => {
  if (!fileName || typeof fileName !== "string") return "";

  const parts = fileName.split(".");
  const extension = parts.length > 1 ? "." + parts.pop() : "";
  const name = parts.join(".");

  if (fileName.length <= maxLength) return fileName;

  const available = maxLength - (extension.length + 3);
  const shortName = name.slice(0, Math.max(available, 1));

  return `${shortName}...${extension}`;
};


export const formatMinutes = (totalMinutes, language) => {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (language === 'ru') {
    return `${hours}ч:${minutes}м`;
  }
  return `${hours}h:${minutes}m`;
};

export const toUrlString = title => title
  .toLowerCase()
  .trim()
  .replace(/[^a-z0-9\s-]/g, '')
  .replace(/\s+/g, '-')
  .replace(/-+/g, '-');

export const padToTwoDigits = num => num.toString().padStart(2, '0');

export const renderNum = (num, enableReduction) => {
  let number = Number(num);

  if (Object.is(number, -0)) number = 0;

  if (enableReduction && isMobileDevice()) {
    if (number >= 1000000) {
      return `${(number / 1000000).toFixed(1).replace(/\.0$/, '')}m`;
    }
    if (number >= 1000) {
      return `${(number / 1000).toFixed(1).replace(/\.0$/, '')}k`;
    }
    return number.toString();
  }

  const separator = i18next.language === 'en' ? ',' : '\u00A0';
  return number.toLocaleString('en-US').replace(/,/g, separator);
};
